"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateDistance = (pLat1, pLon1, pLat2, pLon2) => {
    // localConsole?.time("calculateDistance");
    const lat1 = (pLat1 * Math.PI) / 180.0;
    const lon1 = (pLon1 * Math.PI) / 180.0;
    const lat2 = (pLat2 * Math.PI) / 180.0;
    const lon2 = (pLon2 * Math.PI) / 180.0;
    const a = 6378137.0; // WGS84 major axis
    const b = 6356752.3142; // WGS84 semi-major axis
    const f = (a - b) / a;
    const aSqMinusBSqOverBSq = (a * a - b * b) / (b * b);
    const l = lon2 - lon1;
    let aA = 0.0;
    const u1 = Math.atan((1.0 - f) * Math.tan(lat1));
    const u2 = Math.atan((1.0 - f) * Math.tan(lat2));
    const cosU1 = Math.cos(u1);
    const cosU2 = Math.cos(u2);
    const sinU1 = Math.sin(u1);
    const sinU2 = Math.sin(u2);
    const cosU1cosU2 = cosU1 * cosU2;
    const sinU1sinU2 = sinU1 * sinU2;
    let sigma = 0.0;
    let deltaSigma = 0.0;
    let cosSqAlpha;
    let cos2SM;
    let cosSigma;
    let sinSigma;
    let cosLambda = 0.0;
    let sinLambda = 0.0;
    let lambda = l; // initial guess
    for (let i = 0; i < 19; i++) {
        const lambdaOrig = lambda;
        cosLambda = Math.cos(lambda);
        sinLambda = Math.sin(lambda);
        const t1 = cosU2 * sinLambda;
        const t2 = cosU1 * sinU2 - sinU1 * cosU2 * cosLambda;
        const sinSqSigma = t1 * t1 + t2 * t2;
        sinSigma = Math.sqrt(sinSqSigma);
        cosSigma = sinU1sinU2 + cosU1cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        const sinAlpha = sinSigma == 0.0 ? 0.0 : (cosU1cosU2 * sinLambda) / sinSigma;
        cosSqAlpha = 1.0 - sinAlpha * sinAlpha;
        cos2SM =
            cosSqAlpha == 0.0 ? 0.0 : cosSigma - (2.0 * sinU1sinU2) / cosSqAlpha;
        const uSquared = cosSqAlpha * aSqMinusBSqOverBSq;
        aA =
            1 +
                (uSquared / 16384.0) *
                    (4096.0 + uSquared * (-768 + uSquared * (320.0 - 175.0 * uSquared)));
        const bB = (uSquared / 1024.0) *
            (256.0 + uSquared * (-128.0 + uSquared * (74.0 - 47.0 * uSquared)));
        const cC = (f / 16.0) * cosSqAlpha * (4.0 + f * (4.0 - 3.0 * cosSqAlpha));
        const cos2SMSq = cos2SM * cos2SM;
        deltaSigma =
            bB *
                sinSigma *
                (cos2SM +
                    (bB / 4.0) *
                        (cosSigma * (-1.0 + 2.0 * cos2SMSq) -
                            (bB / 6.0) *
                                cos2SM *
                                (-3.0 + 4.0 * sinSigma * sinSigma) *
                                (-3.0 + 4.0 * cos2SMSq)));
        lambda =
            l +
                (1.0 - cC) *
                    f *
                    sinAlpha *
                    (sigma +
                        cC *
                            sinSigma *
                            (cos2SM + cC * cosSigma * (-1.0 + 2.0 * cos2SM * cos2SM)));
        const delta = (lambda - lambdaOrig) / lambda;
        if (Math.abs(delta) < 1.0e-12) {
            break;
        }
    }
    const mDistance = b * aA * (sigma - deltaSigma);
    // localConsole?.timeEnd("calculateDistance");
    return mDistance;
};
exports.default = calculateDistance;
/**
 * 두 좌표 (lat1, lon1), (lat2, lon2) 사이의 거리를 리턴하는 함수
 *
 * @param pLat1     첫 번째 위도
 * @param pLon1     첫 번재 경도
 * @param pLat2     두 번째 위도
 * @param pLon2     두 번째 경도
 *
 * @return (lat1, lon1), (lat2, lon2) 사이의 미터(m) 단위 거리
 *
 * @see <a href="http://www.ngs.noaa.gov/PUBS_LIB/inverse.pdf">수식 출처</a>의 Section 4 "Inverse Formula"를 사용함
 */
//      fun computeDistance(): Float {
//       // 위도와 경도를 라디안 단위로 변경
//       const mDistance = (b * aA * (sigma - deltaSigma)).toFloat()
//       return mDistance
//   }
